import { render, staticRenderFns } from "./AdminColourList.vue?vue&type=template&id=15171e6e&scoped=true"
import script from "./AdminColourList.vue?vue&type=script&lang=js"
export * from "./AdminColourList.vue?vue&type=script&lang=js"
import style0 from "./AdminColourList.vue?vue&type=style&index=0&id=15171e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15171e6e",
  null
  
)

export default component.exports